import React from 'react';
import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';
import getCheckoutConfig, { CheckoutConfig } from './rules';

export const CheckoutContext = createContext<{
  state: {
    currentStep: number;
    data: Record<string, any>;
    orderInvoice: string;
  };
  setState: Dispatch<
    SetStateAction<{
      currentStep: number;
      data: Record<string, any>;
      orderInvoice:string;
    }>
  >;
  config: CheckoutConfig;
} | null>(null);

export function useCheckout() {
  const ctx = useContext(CheckoutContext);
  return ctx;
}
export default function CheckoutProvider({ children }: { children: ReactNode }): JSX.Element {
  const [state, setState] = useState<{ currentStep: number; data: Record<string, string>, orderInvoice: string}>({
    currentStep: 1,
    data: {},
    orderInvoice: '' 
  });
  const config = getCheckoutConfig();
  return (
    <CheckoutContext.Provider value={{ state, setState, config }}>
      {children}
    </CheckoutContext.Provider>
  );
}
